import router from '@/router'
import RCSListPage from './views/RCSListPage.vue'
import RCSDeatailsPage from './views/RCSDeatailsPage.vue'

router.addRoute({
  path: '/channels/rcs',
  name: 'RCSListPage',
  component: RCSListPage,
  meta: {
    layout: 'dashboard'
  }
})

router.addRoute({
  path: '/channels/rcs/:id',
  name: 'RCSDetailPage',
  component: RCSDeatailsPage,
  meta: {
    layout: 'dashboard'
  }
})
